import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { formatUSD } from '@/services/moneyFormat';

interface CostPerModelData {
    model: string;
    cost: number;
}

interface CostPerModelChartProps {
    data: CostPerModelData[];
}

const CostPerModelChart: React.FC<CostPerModelChartProps> = ({ data }) => {

    const formatTooltipValue = (value: number | undefined) => {
        return [formatUSD(value ?? 0), 'Cost'];
    };

    return (
        <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--muted-foreground))" opacity={0.1} />
                    <XAxis
                        dataKey="model"
                        stroke="hsl(var(--muted-foreground))"
                        fontSize={12}
                        angle={-45}
                        textAnchor="end"
                        height={60}
                    />
                    <YAxis
                        stroke="hsl(var(--muted-foreground))"
                        fontSize={12}
                        tickFormatter={(value) => formatUSD(value)}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: "hsl(var(--background))",
                            borderColor: "hsl(var(--border))",
                            borderRadius: '8px',
                        }}
                        labelStyle={{ color: "hsl(var(--muted-foreground))" }}
                        formatter={formatTooltipValue}
                    />
                    <Bar
                        dataKey="cost"
                        fill="hsl(var(--primary))"
                        radius={[4, 4, 0, 0]}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default CostPerModelChart;

